import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import "moment/locale/es"; // without this line it didn't work
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CheckIcon from "@material-ui/icons/Check";
import { makeStyles } from "@material-ui/core/styles";
import { fetchConToken } from "../../helpers/fetch";
import { startAlerta } from "../../actions/ui/alertas";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import {
  Paper,
  Grid,
  Fab,
  TextField,
  CircularProgress,
  IconButton,
  Typography,
} from "@material-ui/core";
import {
  empresaAfiliadoDeleteStart,
  empresasAfiliadoStartUpdate,
} from "../../actions/empresasAfiliado";
import NuevaEmpresaModal from "../empresas/NuevaEmpresaModal";
import AddIcon from "@material-ui/icons/Add";
import {
  empresasPreafiliadoStartDelete,
  empresasPreafiliadoStartUpdate,
} from "../../actions/empresasPreafiliado";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { AREAS_USUARIOS } from "../../utils/constants";
import { EmpresaModificarModal } from "../empresas/EmpresaModificarModal";

moment.locale("es");

const useStyles = makeStyles({
  root: {
    minWidth: 275,
  },
  buttonOk: {
    marginRight: 10,
  },
  title: {
    fontSize: 14,
    padding: 10,
  },
  pos: {
    marginBottom: 12,
  },
  container: {
    margin: 5,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  autocompletar: {
    backgroundColor: "#90ee90",
  },
  contenidoTexto: {
    fontSize: 14,
    padding: 2,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  },
  texto: {
    fontSize: 14,
    padding: 12,
  },
});

export const EmpresaAfiliadoItem = ({
  item,
  from,
  fromBandeja,
  anteriores,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [empresaAfiliado, setEmpresaAfiliado] = useState(item);
  const [options, setOptions] = useState([]);
  const [textoBuscado, setTextoBuscado] = useState("");
  const [abrirNuevaEmpresa, setAbrirNuevaEmpresa] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [openModifModal, setOpenModifModal] = useState(false);

  const { areas } = useSelector((state) => state.auth);
  const { afiliado } = useSelector((state) => state.afiliacion);
  const { afiliadoEncontrado } = useSelector((state) => state.preinscripto);

  const cargando = open && options.length === 0;

  const handleInputChange = (e) => {
    if (e.target.value.length > 0) {
      setTextoBuscado(e.target.value);
    } else {
      limpiarComponente();
    }
  };

  const limpiarComponente = () => {
    setEmpresaAfiliado({});
    setTextoBuscado("");
    setOptions([]);
    setOpen(false);
  };

  const openModalModif = () => {
    setOpenModifModal(true);
  };

  const handleEmpresaUpdate = (e) => {
    e.preventDefault();
    if (Object.keys(afiliado).length !== 0) {
      dispatch(empresasAfiliadoStartUpdate(empresaAfiliado));
    } else {
      dispatch(empresasPreafiliadoStartUpdate(empresaAfiliado));
    }
  };

  const openModal = () => {
    setAbrirNuevaEmpresa(true);
  };

  const handleEmpresaSeleccionada = (empresa) => {
    if (!!empresa) {
      setEmpresaAfiliado({
        ...empresaAfiliado,
        idEmpresa: empresa.idEmpresa,
        empresa: empresa,
      });
    } else {
      limpiarComponente();
    }
    limpiarComponente();
  };

  const handleDateFechaDesdeChange = (date) => {
    if (
      empresaAfiliado.fechaHasta !== "" &&
      moment(date).isAfter(moment(empresaAfiliado.fechaDesde))
    ) {
      dispatch(
        startAlerta(
          `Fecha desde no puede ser mayor a fecha hasta`,
          "info",
          "Verificar Ingreso"
        )
      );
    } else {
      setEmpresaAfiliado({
        ...empresaAfiliado,
        fechaDesde: date,
      });
    }
  };

  const handleDateFechaHastaChange = (date) => {
    if (moment(empresaAfiliado.fechaDesde).isAfter(moment(date))) {
      dispatch(
        startAlerta(
          `Fecha hasta no puede ser mayor a fecha desde`,
          "info",
          "Verificar Ingreso"
        )
      );
    } else {
      setEmpresaAfiliado({
        ...empresaAfiliado,
        fechaHasta: date,
      });
    }
  };

  useEffect(() => {
    setInputValue(
      `${empresaAfiliado.empresa?.denominacion}  ${empresaAfiliado.empresa?.cuit} 
      ${empresaAfiliado.empresa?.seccional?.descripcion_seccional || "SIN SECCIONAL"}`
    );
  }, [empresaAfiliado.empresa?.denominacion, empresaAfiliado.empresa?.cuit]);

  useEffect(() => {
    let active = true;

    (async () => {
      let texto = textoBuscado.replace("/", "__");
      if (texto.length > 0) {
        const response = await fetchConToken(
          `Empresas/traerPorCUIToDenominacion/${texto}`
        );
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          const lista = await response.json();
          if (active && lista.length > 0) {
            // console.log('resultado',lista);
            setOptions(Object.keys(lista).map((idEmpresa) => lista[idEmpresa]));
          }
        }
      }
    })();
    return () => {
      active = false;
    };
  }, [textoBuscado]);

  useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  const hoy = new Date();
  let fechaHasta = "Actual";
  let fechaDesde = "Sin Datos";
  let fechaHastaString = "Actual";
  let fechaDesdeString = "Sin Datos";
  if (item.fechaDesde !== null) {
    fechaDesde = new Date(item.fechaDesde);
    fechaDesdeString = fechaDesde.toLocaleDateString();
  }
  if (item.fechaHasta !== null) {
    fechaHasta = new Date(item.fechaHasta);
    if (hoy < fechaDesde || hoy > fechaHasta) {
      fechaHastaString = fechaHasta.toLocaleDateString();
    }
  }
  return (
    <>
      <NuevaEmpresaModal
        item={item}
        abrirModal={abrirNuevaEmpresa}
        setAbrirModal={setAbrirNuevaEmpresa}
      />
      <EmpresaModificarModal
        abrirModal={openModifModal}
        setAbrirModal={setOpenModifModal}
        from={from}
        empresaAfiliado={empresaAfiliado}
        setEmpresaAfiliado={setEmpresaAfiliado}
      />
      <Paper
        elevation={3}
        className={classes.container}
        style={{ backgroundColor: anteriores ? "#e0e0e0" : "null" }}
      >
        <Grid
          container
          direction="row"
          justify="space-between"
          alignItems="center"
        >
          <Grid item >
            <Autocomplete
              id={`buscadorEmpresa${empresaAfiliado.idEmpresa}`}
              disabled={true}
              style={{
                padding: 6,
                borderRadius: "5px",
                width: "45vw",
              }}
              inputValue={inputValue}
              onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);
              }}
              loadingText="Buscando..."
              open={open}
              onOpen={() => {
                setOpen(true);
              }}
              onClose={() => {
                setOpen(false);
              }}
              onChange={(event, newValue) => {
                handleEmpresaSeleccionada(newValue);
              }}
              getOptionSelected={(option, value) =>
                option.idEmpresa === value.idEmpresa
              }
              getOptionLabel={(option) =>
                `${option.denominacion} ${option.cuit} ${option.seccional?.descripcion_seccional}`
              }
              renderOption={(option) => (
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <span
                    style={
                      option.fechaBaja === ""
                        ? { color: "green" }
                        : { color: "red" }
                    }
                  >
                    {`${option.denominacion}`}
                  </span>
                  <span
                    style={{
                      fontSize: 12,
                    }}
                  >
                    {" "}
                    {`CUIT:${option.cuit}`}
                  </span>
                </div>
              )}
              options={options}
              loading={cargando}
              renderInput={(params) => (
                <TextField
                  onChange={handleInputChange}
                  style={{
                    padding: 3,
                  }}
                  {...params}
                  label="Denominacion | CUIT | Seccional"
                  variant="outlined"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {cargando ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
          </Grid>

          <Grid item>
            <Typography variant="h6">
              {fechaDesdeString} - {fechaHastaString}
            </Typography>
          </Grid>

          {!(
            areas.filter((e) => e.idArea === AREAS_USUARIOS.NACIONAL).length >
              0 && fromBandeja
          ) && (
            <Grid item>
              <IconButton
                onClick={openModalModif}
                color="primary"
                aria-label="seleccionar"
              >
                <EditIcon />
              </IconButton>
              <IconButton
                onClick={(e) => {
                  if (from === "AFILIACIONES") {
                    dispatch(empresaAfiliadoDeleteStart(empresaAfiliado));
                  } else if (from === "PREAFILIACIONES") {
                    dispatch(empresasPreafiliadoStartDelete(empresaAfiliado));
                  }
                }}
                color="primary"
                aria-label="seleccionar"
              >
                <DeleteIcon />
              </IconButton>
            </Grid>
          )}
          <Grid item>
            {false && (
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <KeyboardDatePicker
                  margin="normal"
                  id={`FD${empresaAfiliado.idEmpresa}`}
                  label={
                    afiliadoEncontrado?.id_tipo_afiliacion === 57 ||
                    afiliado?.id_tipo_afiliacion === 57
                      ? "Fec. Desde Contrato"
                      : "Fec. Ingreso."
                  }
                  format="dd/MM/yyyy"
                  okLabel="Aceptar"
                  required={true}
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  maxDate={new Date()}
                  value={
                    !!empresaAfiliado.fechaDesde &&
                    moment(empresaAfiliado.fechaDesde).isValid()
                      ? moment(empresaAfiliado.fechaDesde)
                      : null
                  }
                  onChange={(date) => {
                    handleDateFechaDesdeChange(date);
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </MuiPickersUtilsProvider>
            )}
            {false &&
              (afiliadoEncontrado?.id_tipo_afiliacion === 57 ||
                afiliado?.id_tipo_afiliacion === 57) && (
                <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    margin="normal"
                    id={`FH${empresaAfiliado.idEmpresa}`}
                    label="Fec. Hasta Contrato."
                    format="dd/MM/yyyy"
                    okLabel="Aceptar"
                    required={true}
                    clearLabel="Limpiar"
                    cancelLabel="Cancelar"
                    //maxDate={new Date()}
                    value={
                      !!empresaAfiliado.fechaHasta &&
                      moment(empresaAfiliado.fechaHasta).isValid()
                        ? moment(empresaAfiliado.fechaHasta)
                        : null
                    }
                    onChange={(date) => {
                      handleDateFechaHastaChange(date);
                    }}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                </MuiPickersUtilsProvider>
              )}
          </Grid>
          {false && (
            <Grid item>
              <Fab
                className={classes.buttonOk}
                variant="extended"
                color="primary"
                aria-label="add"
                size="medium"
                onClick={handleEmpresaUpdate}
              >
                <CheckIcon />
              </Fab>
            </Grid>
          )}
          {false &&
            item.empresa?.denominacion === "NO EMPADRONADA" &&
            areas[0].idArea === 2 && (
              <Grid item>
                <Fab
                  color="secondary"
                  aria-label="add"
                  size="medium"
                  onClick={openModal}
                >
                  <AddIcon />
                </Fab>
              </Grid>
            )}
        </Grid>
      </Paper>
    </>
  );
};
